import airbnb1 from './airbnb1.jpg';
import airbnb2 from './airbnb2.jpg';
import airbnb3 from './airbnb3.jpg';
import airbnb4 from './airbnb4.jpg';

export const airbnbImages = [airbnb1, airbnb2, airbnb3, airbnb4];
